import React, {Component} from 'react';
import {connect} from 'react-redux';

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            credentials: null
        };
    }

    updateCredentials = (userToken) => {
        this.setState({
            credentials: userToken
        });
    };


    render() {
        return (
            <div>
                {this.props.children}
            </div>

        );
    };
}
function mapStateToProps(state) {
    return {...state};
}
export default connect(mapStateToProps)(App);
